import * as React from 'react';
import { useEffect, useState } from 'react';

import axios from 'axios';
import { memoize } from 'lodash';

import { IItem } from '@admin/types/item';
import { IMaterialCategory } from '@admin/types/material_category';

const CATEGORIES = memoize(() => axios.get<IMaterialCategory[]>('/material_categories.json'));

export const MaterialCategoryPreview: React.FC<{
  item: IItem;
}> = ({ item }) => {
  const [category, setCategory] = useState<IMaterialCategory | undefined>(undefined);
  useEffect(() => {
    CATEGORIES().then((response) => {
      setCategory(response.data.find(({ id }) => !!item.packaging && id === item.packaging.material_category_id));
    });
  }, [item]);
  return category ? <>{category.name}</> : null;
};
